import { JSXElementConstructor, ReactElement, ReactNode } from 'react';

import { useTranslation } from 'react-i18next';

import { Select } from 'antd/lib';
import { DefaultOptionType } from 'antd/es/select';
import styles from './selectInput.module.css';

export type SelectOption = {
  label: string | number;
  value: string | number;
  [key: string]: TypeAny;
};

type SelectProps = {
  label?: string;
  value: TypeAny;
  labelTooltip?: React.ReactNode;
  error?: string;
  required?: boolean;
  showSearch?: boolean;
  noSpacing?: boolean;
  disabled?: boolean;
  options: SelectOption[];
  mode?: 'multiple' | 'tags';
  onChange: ((value: TypeAny, option: DefaultOptionType | DefaultOptionType[]) => void) | undefined;
  labelRender?: (props: TypeAny) => ReactNode | undefined;
  dropdownRender?:
    | ((
        menu: ReactElement<TypeAny, string | JSXElementConstructor<TypeAny>>
      ) => ReactElement<TypeAny, string | JSXElementConstructor<TypeAny>>)
    | undefined;
};

export function SelectInput({
  mode,
  value,
  error,
  label,
  labelTooltip,
  required,
  noSpacing,
  disabled,
  onChange,
  options,
  labelRender,
  dropdownRender,
  showSearch
}: SelectProps) {
  const { t } = useTranslation();

  return (
    /* eslint-disable jsx-a11y/no-noninteractive-tabindex */
    <div className={`${styles.selectInputWrap} ${noSpacing ? styles.noSpacing : ''}`}>
      {label && (
        <span className={styles.selectInputLabel}>
          {label}
          {required && ' *'}
          {labelTooltip}
        </span>
      )}
      <Select
        mode={mode}
        value={value}
        options={options}
        showSearch={showSearch}
        filterOption={
          showSearch
            ? (input, option) =>
                ((option?.label as string) ?? '').toLowerCase().includes(input.toLowerCase())
            : undefined
        }
        onChange={onChange}
        className={styles.selectInputContainer}
        placeholder={t('placeholder.select')}
        virtual={false}
        disabled={disabled}
        labelRender={labelRender}
        dropdownRender={dropdownRender}
      />
      <p className={styles.selectError}>{error}</p>
    </div>
  );
}
